/**
 * SectionLabel — sectie-titel met optionele rechts-actie (R11 design system).
 *
 * Props:
 *   children   — label-tekst (verplicht)
 *   action     — ReactNode rechts, bv. een link (optioneel)
 *   as         — element ('p' default, of 'h2'/'h3' voor a11y-hiërarchie)
 *   className  — extra classes (optioneel)
 *
 * Gebruikt de echte index.css-class r11-section-label (B0).
 */
export function SectionLabel({ children, action, as: Tag = 'p', className = '' }) {
  if (action) {
    return (
      <div className={`flex items-center justify-between ${className}`}>
        <Tag className="r11-section-label">{children}</Tag>
        <div className="flex-shrink-0">{action}</div>
      </div>
    )
  }
  return <Tag className={`r11-section-label ${className}`}>{children}</Tag>
}
